import { render } from "./FragmentRedirect.vue?vue&type=template&id=b12826d4"
import script from "./FragmentRedirect.vue?vue&type=script&lang=js"
export * from "./FragmentRedirect.vue?vue&type=script&lang=js"
script.render = render

export default script